"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rgbaToHex = exports.currencyFormatter = exports.validateAllEqual = exports.parseObject = exports.isTrue = exports.findLastIndex = exports.shuffle = exports.fixedShuffleIndex = exports.last = exports.sleep = exports.delay = void 0;
var _ = require("lodash");
/**
 * Delaying functions -- why do we have two..?
 * @TODO: remove delay and sleep function, and use lodash?
 */
var delay = function (time) {
    return new Promise(function (resolve, reject) {
        return setTimeout(function () {
            resolve();
        }, time);
    });
};
exports.delay = delay;
var sleep = function (ms) {
    return new Promise(function (resolve) { return setTimeout(resolve, ms); });
};
exports.sleep = sleep;
/*
 * Some useful tools for functional array processing.
 */
/** Returns last member of an array (without modification). */
var last = function (arr) {
    return arr[arr.length - 1];
};
exports.last = last;
/**
 * Shuffles all elements in any array `arr` EXCEPT for elements who's index is true in `mask`.
 * Adapted from https://codereview.stackexchange.com/a/196629
 */
var fixedShuffleIndex = function (arr, mask) {
    var w = _.shuffle(arr.reduce(function (acc, e, i) {
        if (!mask[i]) {
            acc.push(e);
        }
        return acc;
    }, []));
    return mask.reduce(function (acc, e, i) {
        if (e) {
            acc.splice(i, 0, arr[i]);
        }
        return acc;
    }, w);
};
exports.fixedShuffleIndex = fixedShuffleIndex;
/*
 * Similar to lodash's shuffle function, but allows deterministic shuffle.
 * Adapted from https://stackoverflow.com/a/55480964
 */
var shuffle = function (array, deterministic) {
    if (deterministic === void 0) { deterministic = false; }
    var xor = function (seed) {
        var _a, _b;
        var baseSeeds = [123456789, 362436069, 521288629, 88675123];
        var x = baseSeeds[0], y = baseSeeds[1], z = baseSeeds[2], w = baseSeeds[3];
        var random = function () {
            var _a;
            var t = x ^ (x << 11);
            _a = [y, z, w], x = _a[0], y = _a[1], z = _a[2];
            w = w ^ (w >> 19) ^ (t ^ (t >> 8));
            return w / 0x7fffffff;
        };
        _a = baseSeeds.map(function (i) { return i + seed; }), x = _a[0], y = _a[1], z = _a[2], w = _a[3];
        _b = [0, 0, 0, 0].map(function () { return Math.round(random() * 1e16); }), x = _b[0], y = _b[1], z = _b[2], w = _b[3];
        return random;
    };
    var m = array.length;
    var t;
    var i;
    var random = deterministic ? xor(1) : xor(Math.random());
    while (m) {
        i = Math.floor(random() * m--);
        t = array[m];
        array[m] = array[i];
        array[i] = t;
    }
    return array;
};
exports.shuffle = shuffle;
/**
 * Returns the index of the last element in the array where predicate is true, and -1
 * otherwise.
 * @param array The source array to search in
 * @param predicate find calls predicate once for each element of the array, in descending
 * order, until it finds one where predicate returns true. If such an element is found,
 * findLastIndex immediately returns that element index. Otherwise, findLastIndex returns -1.
 * Code adapted from https://stackoverflow.com/a/53187807
 */
var findLastIndex = function (array, predicate) {
    var l = array.length;
    while (l--) {
        if (predicate(array[l], l, array))
            return l;
    }
    return -1;
};
exports.findLastIndex = findLastIndex;
/**
 * Validate string 'true' and boolean true, and return boolean type
 * Mainly determine query param ?KEY=true / ?KEY=false
 */
var isTrue = function (value) {
    if (typeof value === 'string') {
        return value.toLowerCase() === 'true';
    }
    return value;
};
exports.isTrue = isTrue;
/** Returns @data parsed as JSON, or else unparsed if an error is raised. */
function parseObject(data) {
    try {
        var parsedObject = JSON.parse(data);
        return parsedObject;
    }
    catch (err) {
        return data;
    }
}
exports.parseObject = parseObject;
/** Returns true if all elements in @arr are strictly equal. */
function validateAllEqual(arr) {
    return _.uniq(arr).length === 1;
}
exports.validateAllEqual = validateAllEqual;
/**
 * Currency formatter based on currency and locales.
 * Reference: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat
 */
function currencyFormatter(price, currency) {
    if (currency === void 0) { currency = 'CAD'; }
    var formatter = Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency
    });
    return formatter.format(price);
}
exports.currencyFormatter = currencyFormatter;
/**
 * Converts an RGBA color definition to its matching hex color definition.
 * NOTE: since RGBA controls for opacity, whereas hex does not, this function
 * interprets the RGBA as being shown on white background, and converts that value to hex.
 * adapted from https://www.codegrepper.com/code-examples/javascript/rgba+on+white+background+to+hex
 */
var rgbaToHex = function (rgba, includeHash) {
    if (includeHash === void 0) { includeHash = true; }
    var values = rgba
        .replace(/rgba?\(/, '')
        .replace(/\)/, '')
        .replace(/[\s+]/g, '')
        .split(',');
    var a = parseFloat(values[3] || '1'), r = Math.floor(a * parseInt(values[0]) + (1 - a) * 255), g = Math.floor(a * parseInt(values[1]) + (1 - a) * 255), b = Math.floor(a * parseInt(values[2]) + (1 - a) * 255);
    return ((includeHash ? '#' : '') +
        ('0' + r.toString(16)).slice(-2) +
        ('0' + g.toString(16)).slice(-2) +
        ('0' + b.toString(16)).slice(-2));
};
exports.rgbaToHex = rgbaToHex;
//# sourceMappingURL=index.js.map